<!--
 * @Author: Zyr
 * @Date: 2021-01-07 17:43:53
 * @LastEditTime: 2021-02-22 18:51:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lwdgis-ui-master\src\components\Account\comMainInfo.vue
-->

<template>
    <div class="card-fa-div">
        <el-card class="box-card" style="width: 100%; height:750px;">
            <el-row>
                <h1 style="float:left">积分规则</h1>
            </el-row>   
            <el-row >
                <el-col :offset="2">
                    <h4 style="float:left">等级规则</h4>
                    <div id="divChart" style="height: 300px;width:70%;"></div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :offset="2" :span="20">
                    <h4 style="float:left">积分规则</h4>
                    <el-table :data="point_table">
                            <el-table-column prop="type" label="积分类型"></el-table-column>
                            <el-table-column prop="num" label="积分值"></el-table-column>
                            <el-table-column prop="level" label="等级"></el-table-column>
                        </el-table>
                </el-col>
            </el-row>
        </el-card>
        
        
    </div>
</template>



<script>


export default {
    name:'comMainInfo',
    data(){
      return{
        prizeActivePart:'all',
        displayParam:{
            is_all:true,
            is_book:false,
            is_coupon:false,
            is_necessities:false,
            is_rice:false
        },
        point_table:[{
            type: '添加定位',
            num: '+20',
            level: 'LV1'
          },{
            type: '修改定位',
            num: '+10',
            level: 'LV1'
          },{
            type: '修改定位',
            num: '+10',
            level: 'LV2'
          },{
            type: '添加定位',
            num: '+20',
            level: 'LV2'
          },],
       
                    
      }
    },

  components: {
    
  },

    mounted(){
      this.drawChart()
    },

    methods:{
        drawChart(){
            let option = {
                tooltip: {
                 show:false    
                   
                },
                
                
                xAxis: [
                    {
                        type: 'category',
                        data: $webConfig.level_name,
                        
                        axisTick:{
                            show:false//不显示坐标轴刻度线
                        },
                        axisLine: {
                            show: false,//不显示坐标轴线
                        },
                    }
                ],
                yAxis: {
                    show:false
                    
                },
                series: [
                    {
                        name: '积分',
                        type: 'bar',
                        data: $webConfig.level_num,
                        hoverAnimation:false,
                        barWidth:30,
                        itemStyle: {
                            //柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
                            emphasis: {
                                barBorderRadius: 30
                            },

                            normal: {
                                //柱形图圆角，初始化效果
                                barBorderRadius:[10, 10, 10, 10],
                                label: {
                                    show: true,//是否展示
                                    position: 'top',
                                    textStyle: {
                                        fontSize : '12',
                                        fontFamily : '微软雅黑',
                                    }
                                }
                            }
                        }
                    },

                    
                    
                ]
            }
            let myChart = {}
            myChart = this.$echarts.init(document.getElementById('divChart'))
            myChart.setOption(option)
            window.addEventListener('resize', () => {
                myChart.resize()
            })
        }
        

    }

}
</script>
<style src = '../../css/comm_page.css'></style>
<style scoped>
.prize-demonstration{
    width: 200px; 
    height: 200px;
    float:left;
    display:inline;
    margin: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Account/comPointRule.vue